import axios from "axios";
import { environment } from "../../environments/environment";
import { ListResponse } from "./utils";

interface JobApply {
    id: number,
    jobpost_id: number,
    candidate_id: string,
    status: "applied" | "interview" | "rejected" | "not_fit" | "hired" | "fulfilled",
    reason_id?: number,
    interview_date?: string,
    hired_date?: string
}

interface JobApplyStatus {
    status: "applied" | "interview" | "rejected" | "not_fit" | "hired" | "fulfilled",
    reason_id?: number,
    interview_date?: string,
    hired_date?: string
}

export const applyToJob = async (jobpost_id: number): Promise<any> => {
    const response = await axios.post<any>(environment.apiUrl+'/api/jobapply/', {jobpost_id}, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 201) {
        throw Error('error');
    };

    return response.data;
};

export const jobApplies = async (params?: any): Promise<ListResponse<any>> => {
    const response = await axios.get<any[]>(environment.apiUrl+'/api/jobapply/', {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return { results: response.data, count: response.data.length };
};

export const retriveJobApply = async (id: any): Promise<JobApply> => {
    const response = await axios.get<any>(environment.apiUrl+'/api/jobapply/'+id, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const updateJobApply = async (id: any, body: JobApplyStatus): Promise<any> => {
    const response = await axios.put<any>(environment.apiUrl+'/api/jobapply/'+id, 
        body,
        {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 204) {
        throw Error('error');
    };

    return response.data;
};

export const listJobApplies = async (id: any): Promise<any[]> => {
    const response = await axios.get<any>(environment.apiUrl+'/api/jobpost/candidates?jobpost_id='+id, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};